import axios from "axios";

const instance = axios.create({
  baseURL: `${window.location.origin}`,
  withCredentials: false,
});

const headers = {
"Content-Type": "application/json",
};

export const fetchAuditsByOrg = async (user, orgId) => {
  const response = await fetch(`/api/auditing/${orgId}/audits-by-org`, {
    headers: {
      // prettier-ignore
      'Authorization': `Bearer ${user.token}`
    }
  });
  //convert again json array of objects to javascript array of objects
  const json = await response.json();
  if (response.ok) {
    return json;
  } else {
    throw new Error(json?.msg || `Failed to fetch audit log for org id: ${orgId}`);
  }
};

export const fetchAuditsByUser = async (user) => {
  const response = await fetch(`/api/auditing/${user?.userId ?? '0'}/audits-by-user`, {
    headers: {
      // prettier-ignore
      'Authorization': `Bearer ${user.token}`
    }
  });
  //convert again json array of objects to javascript array of objects
  const json = await response.json();
  if (response.ok) {
    return json;
  } else {
    throw new Error(json?.msg || `Failed to fetch audit log for user id: ${user?.userId}`);
  }
};

export const chatBotAI = async ({message, threadId}) => {
  const body = { message, threadId };
  const response = await instance.post("api/sso/getAiRequest", body, { headers })
  // instance
  //     .post("api/sso/getAiRequest", body, { headers })
  //     .then(response => {
  //       console.log("response", response.data?.message)
  //       return response.data?.message;
  //     })
  //     .catch(error => {
  //       console.error("Error on chatBotAI", error)
  //       return null;
  //     });
  console.log({response})
  if (response.status === 200) {
    const res = response.data.body.data[0]
    return {answer: res?.content?.[0]?.text?.value, threadId: res?.thread_id};
  } else {
    throw new Error(`chatBotAI error: ${response?.data?.error}`);
  }

}
